<footer class="bg-white border-t border-gray-200 py-2">
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <p class="text-center text-sm text-gray-500">
      Powered by
      <a
        href="https://airgateway.com"
        target="_blank"
        class="text-gray-500 no-underline hover:text-primary transition"
      >
        AirGateway GmbH
      </a>
      &middot; {{ year }} &middot; Version:
      <span class="font-mono tabular-nums text-gray-500">{{ version() ?? '—' }}</span>
      - Env:
      <span class="font-mono text-gray-500">{{ env }}</span>
    </p>
  </div>
</footer>
